<template>
	<AdaptiveContainer class="relative flex justify-between z-10">
		<BaseHeading
			type="h5"
			class="my-9 col-span-full relative before:content-['&nbsp;'] before:block before:absolute before:-bottom-1 before:h-1 before:w-20 before:bg-red-500"
		>
			{{ $t("highlightedCompanies") }}
		</BaseHeading>
		<div class="text-sm hidden sm:flex sm:items-center">
			<NuxtLink :to="`/${$i18n.locale}/companies?highlightedgold=true`" class="text-sm">
				{{ $t("allCompanies") }}
				<span class="material-icons-outlined pl-2 text-base">arrow_forward</span>
			</NuxtLink>
		</div>
	</AdaptiveContainer>
	<CarouselCompanies
		ref="carouselCompaniesRef"
		:slideWidth="320"
		:showBanner="!isMobileScreen() && Object.keys(banner).length > 0"
		:banner="banner"
	></CarouselCompanies>

	<!-- Mobile Banner -->
	<AdaptiveContainer v-if="Object.keys(banner).length > 0 && isMobileScreen() == true">
		<DjCardCompanyBanner
			:subtitle="localized(banner.sub_title)"
			:title="localized(banner.title)"
			:description="localized(banner.content)"
			:cta="localized(banner.cta_text)"
			:url="localized(banner.cta_link)"
			:logo="banner.image.cloudinary"
			class="mt-5 mb-10"
		/>
	</AdaptiveContainer>
	<div class="sm:hidden mb-6">
		<NuxtLink
			:to="`/${$i18n.locale}/companies`"
			class="w-full flex justify-center items-center bg-dj-blue/5 text-sm text-dj-blue hover:bg-dj-blue/10 active:bg-dj-blue/10 max-w-[320px] mx-auto mb-4 p-3 rounded-normal"
		>
			{{ $t("allCompanies") }}
			<span class="material-icons-outlined pl-2">arrow_forward</span>
		</NuxtLink>
	</div>
</template>

<script lang="ts">
import { ref, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { type bannerObject } from "@@/types";

export default defineComponent({
	name: "Companies",
	setup() {
		const carouselCompaniesRef = ref<{ isMobile?: () => boolean } | null>(null);

		const isMobileScreen = () => {
			return carouselCompaniesRef.value?.isMobile?.() || false;
		};
		const { locale } = useI18n();

		function localized(value: unknown) {
			const localeMap = value as Record<string, string> | undefined;
			return localeMap?.[locale.value] || "";
		}

		onMounted(() => {
			requestBannerHighlightedCompanies().catch(() => undefined);
		});

		const banner = ref({} as bannerObject);

		async function requestBannerHighlightedCompanies() {
			banner.value = await useBanners.getBanner("higlighted-companies");
		}

		return {
			carouselCompaniesRef,
			isMobileScreen,
			locale,
			localized,
			banner,
		};
	},
});
</script>
